class EsimCheck extends HTMLElement {
    constructor() {
        super();
        this.getBrand = false;
        this.getModel = false; // 初始化模型点击状态
        this.defaultModelTitle = ''; // 初始化默认值
    }

    connectedCallback() {
        this.initCheckerBrand();
        this.recordDefaultModelTitle(); // 记录初始化的默认值
        this.clickCheckerHeader();
        this.clickCheckerValue();
        this.checkInput(); // 初始化检查输入方法
        this.checkEsim(); // 初始化eSIM检查方法
        this.checkAgain(); // 初始化重新检查方法
    }

    query(selector) {
        return this.querySelector(selector);
    }

    queryAll(selector) {
        return this.querySelectorAll(selector);
    }

    initCheckerBrand() {
        const checkJsonElement = this.query('.esim-check-json');
        if (!checkJsonElement) {
            console.error('.esim-check-json 元素未找到');
            return;
        }

        let jsonData;
        try {
            jsonData = JSON.parse(checkJsonElement.textContent.trim());
            console.log('JSON解析成功:', jsonData);
        } catch (error) {
            console.error('无法解析为JSON:', error);
            return;
        }

        const brandListElement = this.query('.esim-check-form__checker_brand__list');
        if (!brandListElement) {
            console.error('品牌列表元素未找到');
            return;
        }

        // 生成品牌元素
        Object.keys(jsonData).forEach(brand => {
            const brandItem = document.createElement('div');
            brandItem.className = 'esim-check-form__checker_item esim-check-form__checker_brand-item';
            brandItem.textContent = brand;
            brandItem.addEventListener('click', () => {
                this.getBrand = true;
                this.getModel = false; // 重置模型点击状态
                this.initCheckerModel(jsonData[brand]);
            });
            brandListElement.appendChild(brandItem);
        });
    }

    initCheckerModel(models) {
        const modelBox = this.query('.esim-check-form__checker_model_box');
        if (!this.getBrand) {
            modelBox.setAttribute('disabled', 'true');
            return;
        }
        modelBox.setAttribute('disabled', 'false');
        const modelListElement = this.query('.esim-check-form__checker_model__list');
        modelListElement.innerHTML = ''; // 清空原有内容

        models.forEach(modelObj => {
            const modelName = Object.keys(modelObj)[0];
            const modelItem = document.createElement('div');
            modelItem.className = 'esim-check-form__checker_item esim-check-form__checker_model-item';
            modelItem.textContent = modelName;
            modelItem.dataset.compatible = modelObj[modelName]; // 记录true/false值
            modelItem.addEventListener('click', () => {
                this.getModel = true; // 记录模型被点击
                this.checkInput(); // 每次点击后检查按钮状态
            });
            modelListElement.appendChild(modelItem);
        });
    }

    recordDefaultModelTitle() {
        const modelTitle = this.query('.esim-check-form__checker_model__title p');
        if (modelTitle) {
            this.defaultModelTitle = modelTitle.textContent; // 记录默认值
        }
    }

    clickCheckerHeader() {
        const headers = this.queryAll('.esim-check-form__checker__box-title');
        headers.forEach(header => {
            header.addEventListener('click', () => {
                const isActive = header.classList.contains('active');

                // 移除所有“active”类
                this.queryAll('.esim-check-form__checker__box-title.active')
                    .forEach(title => title.classList.remove('active'));
                this.queryAll('.esim-check-form__checker__box-list.active')
                    .forEach(list => list.classList.remove('active'));

                // 如果点击的不是打开状态，则为点击的header及其对应的list添加“active”类
                if (!isActive) {
                    header.classList.add('active');
                    const list = header.nextElementSibling;
                    if (list && list.classList.contains('esim-check-form__checker__box-list')) {
                        list.classList.add('active');
                    }
                }
            });
        });
    }

    clickCheckerValue() {
        const checkForm = this.query('.esim-check-form');
        if (checkForm) {
            checkForm.addEventListener('click', (event) => {
                const item = event.target.closest('.esim-check-form__checker_item');
                if (item && item.classList.contains('esim-check-form__checker_item')) {
                    const container = item.closest('.esim-check-form__checker__box-container');
                    const header = container ? container.querySelector('.esim-check-form__checker__box-title p') : null;
    
                    if (header) {
                        header.textContent = item.textContent;
                    }
    
                    // 检查是否点击的是品牌项
                    if (item.classList.contains('esim-check-form__checker_brand-item')) {
                        const modelTitle = this.query('.esim-check-form__checker_model__title p');
                        if (modelTitle) {
                            modelTitle.textContent = this.defaultModelTitle; // 重置为默认值
                        }
                        this.getModel = false; // 选择了品牌项，重置模型状态
                    } else if (item.classList.contains('esim-check-form__checker_model-item')) {
                        // 仅在模型项被点击时更新状态和按钮状态
                        this.getModel = true;
                        this.checkInput(); // 每次点击后检查按钮状态
                    }
    
                    // 只移除当前container中的active类
                    const activeItems = container.querySelectorAll('.esim-check-form__checker_item.active');
                    activeItems.forEach(activeItem => activeItem.classList.remove('active'));
    
                    // 为当前点击的item添加active类
                    item.classList.add('active');
    
                    // 取消其他不相关元素的active类
                    this.queryAll('.esim-check-form__checker__box-title.active')
                        .forEach(title => title.classList.remove('active'));
                    this.queryAll('.esim-check-form__checker__box-list.active')
                        .forEach(list => list.classList.remove('active'));
                }
            });
        }
    }

    checkInput() {
        const checkButton = this.query('.esim-check-form__button');
        if (checkButton) {
            const shouldEnable = this.getBrand && this.getModel;
            checkButton.disabled = !shouldEnable;
            if (shouldEnable) {
                checkButton.removeAttribute('disabled');
            } else {
                checkButton.setAttribute('disabled', 'true');
            }
        }
    }


    checkEsim() {
        const checkButton = this.query('.esim-check-form__button');
        if (checkButton) {
            checkButton.addEventListener('click', () => {
                this.hideForm();
                this.modifyDevice();

                // 获取选中的模型
                const selectedModel = this.query('.esim-check-form__checker_model__list .esim-check-form__checker_item.active');
                const isCompatible = selectedModel ? selectedModel.dataset.compatible === 'true' : false;

                if (isCompatible) {
                    this.query('.esim-check-form__result_success').style.display = 'flex';
                } else {
                    this.query('.esim-check-form__result_fail').style.display = 'flex';
                }
            });
        }
    }

    modifyDevice() {
        const selectedBrand = this.query('.esim-check-form__checker_brand__list .esim-check-form__checker_item.active');
        const selectedModel = this.query('.esim-check-form__checker_model__list .esim-check-form__checker_item.active');

        if (selectedBrand && selectedModel) {
            const deviceText = `${selectedBrand.textContent} ${selectedModel.textContent}`;
            const resultTextElements = this.queryAll('.esim-check-form__result__text span');
            resultTextElements.forEach(span => {
                span.textContent = deviceText;
            });
        }
    }


    hideForm() {
        const formInner = this.query('.esim-check-form__inner');
        if (formInner) {
            formInner.style.display = 'none';
        }
    }

    checkAgain() {
        const checkAgainButtons = this.queryAll('.check-another-phone');
        checkAgainButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.showForm();
                this.queryAll('.esim-check-form__result_box').forEach(box => box.style.display = 'none');
            });
        });
    }

    showForm() {
        const formInner = this.query('.esim-check-form__inner');
        if (formInner) {
            formInner.style.removeProperty('display');
        }
    }
}

customElements.define('esim-check', EsimCheck);
